import { createApp, VueElement } from 'vue';
import VueToast from 'vue-toast-notification';
import { createI18n } from 'vue-i18n';

import languages from '@/i18n/index';

import utilsPlugin, {
  servertranslate, trim, truncate, formatDate,
} from '@/plugins/utils';
import App from './App.vue';

import './registerServiceWorker';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';

import 'vue-toast-notification/dist/theme-default.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import './assets/scss/main.scss';

const app = createApp(App);

const langState: any = store.state;
const i18n = createI18n({
  locale: langState.lang.lang,
  fallbackLocale: 'en',
  messages: languages,
  legacy: false,
  globalInjection: true,
});
app.use(i18n);

app.use(VueToast, {
  // VueToast options go here if needed
});

app.use(router);
app.use(store);
app.use(vuetify);
// register plugin
app.use(utilsPlugin);

app.config.errorHandler = (err, instance, info) => {
  console.error('Global Vue Error:', err, info, instance);
};

app.mount('#app');

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $toast: any;
    $t: typeof i18n.global.t;
    $router: any;
    $store: any;
    $route: any;
    $utils: {
      servertranslate: typeof servertranslate;
      trim: typeof trim;
      truncate: typeof truncate;
      formatDate: typeof formatDate;
    };
  }
}
